import React from 'react';


export const Header = (props) => {
  console.log(props.data);
  return (
      <h2 className='white'>New albums & singles</h2>
  );
}


